import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { FormControl } from '@angular/forms';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { IActivity } from 'src/app/interfaces/resource';
import { Location } from '@angular/common';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { ActivityStore } from 'src/app/stores/resources/activity.store';

@Component({
  selector: 'app-training-activity',
  templateUrl: './training-activity.component.html',
  styleUrls: ['./training-activity.component.scss']
})
export class TrainingActivityComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TABS.ACTIVITY;
  MODULE_KEY: any;
  DISPLAY_STATUS_KEY: any;
  page: any;
  status: any;
  search: any;
  size = APPS.SIZE
  MODULE: any;
  searchTextBox = new FormControl(null, []);
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private location: Location,
    private dialog: MatDialog,
    public activity: ActivityStore,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.MODULE_KEY = param['id'];
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['code']];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchSelectedData(COLLECTION_NAME.MODULE, this.MODULE_KEY, doc => {
        this.MODULE = doc;
        if (!doc) {
          this.router.navigate([`/modules`])
        }
      })
      this.store.fetchActivity(this.MODULE_KEY, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey)
    })
  }


  create() {
    this.router.navigate([`/modules/activity-types/${this.MODULE_KEY}`])
  }

  goBack() {
    this.router.navigate([`/modules/submitted`])
  }

  onDelete(item) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: item.name, title: 'Delete Activity' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.activity.delete(item, (success, res) => {
          this.snackBar.open("Activity has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

  onActivity(item: IActivity) {
    this.router.navigate([`/modules/activity-type/${item.activityTypeKey}/${item.skillKey}/${item.moduleKey}/${item.key}`])
  }
}
